export default __webpack_public_path__ + "static/media/brooms.21b054e5.png";